__turbopack_context__.v({
  "aside": "content-split-module-scss-module__RDl7lq__aside",
  "contentSplit": "content-split-module-scss-module__RDl7lq__contentSplit",
  "emptyAside": "content-split-module-scss-module__RDl7lq__emptyAside",
  "invertMobileOnly": "content-split-module-scss-module__RDl7lq__invertMobileOnly",
  "inverted": "content-split-module-scss-module__RDl7lq__inverted",
  "main": "content-split-module-scss-module__RDl7lq__main",
  "title": "content-split-module-scss-module__RDl7lq__title",
  "withVerticalCenter": "content-split-module-scss-module__RDl7lq__withVerticalCenter",
});
